import {SimplePresentation} from "./SimplePresentationRunner";
import {Possessed} from "../../Possessed";
import {gsap} from "gsap"

export class FullScreenSymbolPresentation extends SimplePresentation {

    constructor() {
        super("FullScreenSymbol");
    }

    shouldRun(): boolean {
        return Possessed.model.parsedEvaluatedArea.filter(s => s.symbol == "M1").length == 24;
    }

    skip() {

    }

    buildTimeline() {
        const tl = this.tl;
        tl.add(Possessed.reelView.playFullScreenM1());
        tl.add(() => {
            Possessed.soundPlayer.playSound("m1Full")
        }, "<")
    }
}